export const SETACTIVITYSAVE = "SETACTIVITYSAVE";
export const SETACTIVITY = "SETACTIVITY";